import { useLocation } from "react-router-dom";
import ModuleComponent from "../../../components/academy/module/module";

const AcademyModule = () => {
  const location = useLocation();
  return (
    <div className="w-full">
      <ModuleComponent key={location.pathname} />
    </div>
  );
};

export default AcademyModule;
